import React from 'react';
import { connect } from "react-redux";
import {hashHistory} from "react-router";
import {FormattedMessage} from "react-intl";

import {
  changeActivePartRelatedItemIndex, setCameFromPage,
  setQtActiveCategory,
  setVanityType,
  toggleBathroomVisualizerOpen, toggleSelectionWindow
} from "../../actions/actionFunctions";
import DesktopHeader from "../desktopHeader";
import ProjectScopeFunctions from "../projectScope/projectScopeFunctions";
import {renderErrorPopup} from "../../api/api-popups";
import {showWizardInsteadOfQT} from "../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import goToMaterialPage from "../common/goToMaterialPage";

class QuoteDesignPage extends ProjectScopeFunctions {

  componentDidMount() {
    if (this.props.bvOpened) {
      this.props.toggleBathroomVisualizerOpen(false);
    }
  }

  goToVisualizer = () => {
    this.props.toggleBathroomVisualizerOpen(true);
    this.props.setVanityType(true);
    hashHistory.push('visualizer');
  };

  goToQuotingTool = () => {
    const {wizardList, wizardIsActive} = this.props;
    if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
      goToMaterialPage();
      return
    }
    const section = this.getSections()[0];
    if (!section || !section.items || !section.items[0]) {
      renderErrorPopup("Error: No Project Scope Feature Groups Available");
      hashHistory.push('/materials');
      return
    }
    this.goToMaterialsPageCommon(section.items[0].part, section.title);
  };

  render() {
    const buttonClass = this.props.windowWidth > 991 ? "ui-button3 ui-button3--blue" : "ui-button2 ui-button2--blue";
    return (
      <div className="qt-des">
        {this.props.windowWidth > 991 ? <DesktopHeader uploadsAndNotes={false} hideTopButtons={true}/> : null}
        <div className="qt-des-content">
          <div className="qt-des-sections">
            <section className="qt-des-sections__section qt-des-sections__section--shop">
              <h2 className="qt-des-title">
                <span className="qt-des-title__main"><FormattedMessage id="quoteDesignPage.shopSection.title1"/></span>
                <span className="qt-des-title__text"><FormattedMessage id="quoteDesignPage.shopSection.title2"/></span>
              </h2>
              <div className="qt-des-button">
                <button className={buttonClass} onClick={this.goToQuotingTool}>
                  <FormattedMessage id="quoteDesignPage.shopSection.button"/>
                </button>
              </div>
            </section>
            <section className="qt-des-sections__section qt-des-sections__section--visualize">
              <h2 className="qt-des-title text-right">
                <span className="qt-des-title__main">
                  <FormattedMessage id="quoteDesignPage.designSection.title1"/>
                </span>
                <span className="qt-des-title__text">
                  <FormattedMessage id="quoteDesignPage.designSection.title2"/>
                </span>
              </h2>
              <div className="qt-des-button">
                <button className={buttonClass} onClick={this.goToVisualizer}>
                  <FormattedMessage id="quoteDesignPage.designSection.button"/>
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => {
  const {wizardList, wizardIsActive} = store.wizardState;
  return {
    wizardList,
    wizardIsActive,
    windowWidth: store.serverState.windowWidth,
    bvOpened: store.bathroomVisualizerState.bvOpened,
  };
};

export default connect(mapStateToProps, {
  toggleBathroomVisualizerOpen,
  setVanityType,
  setQtActiveCategory,
  changeActivePartRelatedItemIndex,
  toggleSelectionWindow,
  setCameFromPage
})(QuoteDesignPage);
